/* @flow */

import Immutable from 'immutable';
import forEach from 'lodash/forEach';
import ObjectPath from 'object-path';
import { asyncWrapper } from './async';
import { ViewConstants } from '../constants/view_constants';
import { ViewSelectors } from '../stores/view_selectors';
import { DatasetActionCreators } from '../stores/dataset_action_creators';
import * as APIClient from '../util/api_client';

var ViewActionCreators = {
  setView: function(viewId: string, loadingType: ?LoadingType = 'blocking'): Function {
    return (dispatch, getState) => {
      if (!ViewSelectors.hasViewLoaded(getState(), viewId)) {
        return asyncWrapper(APIClient.viewLoad(viewId).then(viewSettings => {
          dispatch({
            type: ViewConstants.VIEW_LOAD,
            viewId,
            viewSettings
          });

          dispatch({
            type: ViewConstants.VIEW_SET_ACTIVE,
            viewId
          });

          if (viewSettings.interactiveSources) {
            forEach(viewSettings.interactiveSources, dataset => {
              dispatch(DatasetActionCreators.loadDatasetById(dataset.ownerId, dataset.datasetId, 'silent'));
            });
          }

          if (viewSettings.search && viewSettings.search.datasets) {
            forEach(viewSettings.search.datasets, dataset => {
              dispatch(DatasetActionCreators.loadDatasetById(dataset.ownerId, dataset.datasetId, 'silent'));
            });
          }

        }), loadingType, dispatch);
      }
      else {
        dispatch({
          type: ViewConstants.VIEW_SET_ACTIVE,
          viewId
        });
      }
    };
  },
  toggleMenu: function(): Object {
    return {
      type: ViewConstants.VIEW_TOGGLE_MENU
    }
  },
};

export { ViewActionCreators };
